<div class="flex-row muni-management-container" *ngIf="municipalityConfig$ | async as config">
  <div class="container-left">
    <app-municipality-information-tab></app-municipality-information-tab>
    <app-damage-report-tab *ngIf="isTabEnabled"></app-damage-report-tab>
  </div>
  <div class="container-right flex-stretch">
    <app-features-activation-tab (hideButton)="hide($event)"></app-features-activation-tab>
    <div class="button-group">
      <button
        *ngIf="displayDownloadBtn && (tabIndex !== 2 || (tabIndex === 2 && (externeAppsFacadeService.featurePermissions$ | async)?.length > 0))"
        (click)="downloadReport()"
        class="btn-download btn btn-outline-primary"
      >
        <i class="fa fa-arrow-down"> </i>
        {{ 'module.userProfile.generalConfiguration.downloadButtonText' | translate }}
      </button>
      <button
        *ngIf="tabIndex !== 2 || (tabIndex === 2 && (externeAppsFacadeService.featurePermissions$ | async)?.length > 0)"
        (click)="cancel()"
        class="btn btn-outline-secondary"
      >
        {{ 'module.userProfile.generalConfiguration.cancelButtonText' | translate }}
      </button>
      <button
        *ngIf="tabIndex !== 2 || (tabIndex === 2 && (externeAppsFacadeService.featurePermissions$ | async)?.length > 0)"
        (click)="showSaveModal()"
        class="btn btn-outline-primary"
        [disabled]="isSaveButtonDisabled$ | async"
      >
        <span class="fa fa-floppy-o"></span>
        {{ 'module.userProfile.generalConfiguration.confirmButtonText' | translate }}
      </button>
    </div>
  </div>
</div>
